import { Box, Dialog, Typography } from "@mui/material";
import styles from "../Accounts/Accounts.module.scss";
import { Close } from "@mui/icons-material";
import {
  CommonButton,
  CommonOutlinedButton,
  CustomRequiredInputLabel,
  CustomTextFeild,
} from "../../common/StyledComponents/StyledFields";
import ButtonLoader from "../../common/ButtonLoader/ButtonLoader";
import { useState } from "react";
import { useFormik } from "formik";
import { object, string } from "yup";
import {
  apiRequest,
  catchErrorMessageHandler,
} from "../../../infrastructure/backendService";
import apiPath from "../../../config/apiPaths.json";
import toast from "react-hot-toast";
import SuccessPopup from "../../devotee/donation/successPopup";
import ErrorPopup from "../../common/ErrorPopup";

const CreateSubAccount = (props: any) => {
  const {
    open,
    handleClose,
    mainAccount,
    handleCloseGetAccounts,
    expenseAccounts,
    handleAddSubAccount,
  } = props;
  const [isBtnLoading, setIsBtnLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      subAccount: "",
    },
    validationSchema: object().shape({
      subAccount: string().trim().required("Sub-Account title is required"),
    }),
    onSubmit(values) {
      setIsBtnLoading(true);
      handleCreateAccount(values);
    },
    enableReinitialize: true,
  });

  const handleCreateAccount = (values: any) => {
    const payload = {
      description: values?.subAccount,
      mainAccount: false,
      accountId: mainAccount,
      category: expenseAccounts?.find(
        (account: any) => account?.accountId === mainAccount
      )?.category,
    };
    apiRequest({
      method: "POST",
      endpoint: apiPath.createAccount,
      includeToken: true,
      body: payload,
    })
      .then((res) => {
        setIsBtnLoading(false);
        toast.custom(
          <SuccessPopup
            headerMessage="Create New Sub-Account"
            showMessage={`Successfully created the sub-account`}
          />
        );
        formik.resetForm();
        handleCloseGetAccounts?.();
        handleAddSubAccount?.(res?.data);
      })
      .catch((err) => {
        setIsBtnLoading(false);
        toast.custom(
          <ErrorPopup showMessage={catchErrorMessageHandler(err)} />
        );
      });
  };

  const renderFieldsComponent = () => {
    return (
      <Box sx={{ maxWidth: "100%", width: "320px" }}>
        {CustomRequiredInputLabel("Sub-Account Title", true)}
        <CustomTextFeild
          fullWidth
          required
          value={formik.values.subAccount}
          className={styles.textField}
          onChange={formik.handleChange}
          name="subAccount"
          placeholder="Sub-account title"
          InputProps={{
            inputProps: {
              maxLength: 50,
            },
          }}
        />
        {formik.touched.subAccount && formik?.errors?.subAccount && (
          <Typography sx={{ color: "red", fontSize: "12px" }}>
            {formik?.errors?.subAccount}
          </Typography>
        )}
      </Box>
    );
  };

  const renderButtonsComponent = () => {
    return (
      <Box className={styles.buttonsContainer} sx={{ mt: "20px" }}>
        <CommonButton
          onClick={() => {
            !isBtnLoading && formik.handleSubmit();
          }}
          sx={{ mr: "10px" }}
        >
          <ButtonLoader isBtnLoading={isBtnLoading} btnText={"Submit"} />
        </CommonButton>
        <CommonOutlinedButton
          onClick={() => {
            !isBtnLoading && handleClose();
          }}
        >
          Cancel
        </CommonOutlinedButton>
      </Box>
    );
  };

  return (
    <Dialog
      onClose={handleClose}
      open={open}
      PaperProps={{
        sx: {
          width: { xs: "100%", md: "710px" },
          maxWidth: { xs: "100%", sm: "710px" },
          margin: { xs: "10px", sm: "20px" },
        },
      }}
    >
      <Box
        className={styles.dialog_main_container}
        sx={{
          width: "100%",
        }}
      >
        <Box className={styles.dialog_title_container}>
          <Typography className={styles.title}>
            Create New Sub-Account
          </Typography>
          <Close
            sx={{ color: "white", cursor: "pointer" }}
            onClick={handleClose}
          />
        </Box>
        <Box className={styles.dialog_inner_container}>
          {renderFieldsComponent()}
          {renderButtonsComponent()}
        </Box>
      </Box>
    </Dialog>
  );
};

export default CreateSubAccount;
